export default {
  twitter: {
    name: 'Twitter',
    width: 1024,
    height: 512,
    iconName: 'twitter.svg',
  },
  stories: {
    name: 'Stories',
    width: 1080,
    height: 1920,
    iconName: 'facebook.svg',
  },
  instagram: {
    name: 'Instagram',
    width: 1080,
    height: 1080,
    iconName: 'instagram.svg',
  },
  facebook: {
    name: 'Facebook',
    width: 940,
    height: 788,
    iconName: 'facebook.svg',
  },
};
